// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CanonicalAddress,
} from "./types";


export default __t.row({
  firstName: __t.option(__t.string()).name("first_name"),
  lastName: __t.option(__t.string()).name("last_name"),
  phone: __t.option(__t.string()),
  dob: __t.option(__t.string()),
  citizenship: __t.option(__t.string()),
  residency: __t.option(__t.string()),
  get address() {
    return __t.option(CanonicalAddress);
  },
  avatarCdnPath: __t.option(__t.string()).name("avatar_cdn_path"),
  isAccreditedInvestor: __t.option(__t.bool()).name("is_accredited_investor"),
});
